import eventstoreUiComponentsGlobalScript from '/home/runner/work/Design-System/Design-System/packages/components/dist/collection/init.js';
import esLayoutGlobalScript from '/home/runner/work/Design-System/Design-System/packages/layout/src/init.ts';
export const globalScripts = () => {
  return Promise.all([
    esLayoutGlobalScript(),
    eventstoreUiComponentsGlobalScript(),
  ]);
};
